// extracted by mini-css-extract-plugin
export default {"container":"ProfitsGraph_container__0mG6C","title":"ProfitsGraph_title__gXi5+","lastUpdated":"ProfitsGraph_lastUpdated__2YxSS","graphWrapper":"ProfitsGraph_graphWrapper__slbLX"};